module.exports = __webpack_public_path__ + "img/Grupo 1578@2x.ac7bee5f.png";